import NavigationLink from 'app/components/header/navigation/NavigationLink';
import { IModalProps } from 'app/components/presentation/modals/Modal';
import React, { ComponentType, FC, Fragment, ReactElement, useCallback, useState } from 'react';

interface IModalNavigationLinkProps {
  icon?: ComponentType<{ className?: string }>;
  renderModal: ({ onClose }: { onClose: () => void }) => ReactElement<IModalProps, ComponentType<IModalProps>>;
}

/**
 * Presents a navigation link that when clicked, shows a modal.
 */
const ModalNavigationLink: FC<IModalNavigationLinkProps> = ({ children, icon, renderModal }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = useCallback(() => {
    setIsOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  return (
    <Fragment>
      <NavigationLink icon={icon} to={null} onClick={handleClick}>
        {children}
      </NavigationLink>
      {isOpen && renderModal({ onClose: handleClose })}
    </Fragment>
  );
};

export default ModalNavigationLink;
